import React from 'react';
import { injectIntl } from 'react-intl';
import { uniq as _uniq, map as _map, find as _find, filter as _filter } from 'lodash';

import IntlDate from 'components/layout/IntlDate';

import Modal from 'components/Modal';

class FilledQuestionnaireDetails extends React.Component {
  getQuestionsIndex = () => {
    const { filledQuestionnaire } = this.props;
    if (!filledQuestionnaire.pending) {
      return _uniq(_map(filledQuestionnaire.data.answers, 'question_index'));
    }

    return null;
  };

  getQuestionTitle = questionIndex => {
    const { filledQuestionnaire } = this.props;
    const answer = _find(filledQuestionnaire.data.answers, ['question_index', questionIndex]);
    return <dt class="m-t-5">{answer.question}</dt>;
  };

  getQuestionAnswers = questionIndex => {
    const { filledQuestionnaire } = this.props;
    const answers = _filter(filledQuestionnaire.data.answers, ['question_index', questionIndex]);

    return (
      <dd>
        {answers.map(answer => {
          return <div key={answer.answer_index}>{answer.answer}</div>;
        })}
      </dd>
    );
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      filledQuestionnaire,
    } = this.props;

    const questionsIndex = this.getQuestionsIndex();

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.answers_to_a_questionnaire}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <dl>
            <dt className="m-t-5">{messages.questionnaire}</dt>
            <dd>{filledQuestionnaire.data.name}</dd>

            <dt class="m-t-5">{messages.filled_out_on}</dt>
            <dd>
              <IntlDate date={filledQuestionnaire.data.cdate} />
            </dd>

            {!!questionsIndex &&
              questionsIndex.map(questionIndex => {
                return (
                  <React.Fragment key={questionIndex}>
                    {this.getQuestionTitle(questionIndex)}
                    {this.getQuestionAnswers(questionIndex)}
                  </React.Fragment>
                );
              })}
          </dl>
        </Modal.Body>
      </Modal>
    );
  }
}

export default injectIntl(FilledQuestionnaireDetails);
